import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import theme from '@ecp/common/src/style/theme/default';
import { FlexBox, FlexBoxColumn, HorizontalDivider } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import ChipSearch from '@ecp/common/src/components/chip/ChipSearch';
import Swiper from '@ecp/common/src/components/swiper/Swiper';

import SearchHistoryHeader from '@fo-pages/search/components/SearchHistoryHeader';

const EmptyList = ({ text }) => {
  return (
    <Box>
      <TextBox size={theme.font.size.$25} weight={theme.font.weight.demiLight} color={theme.color.text.guide}>
        {text}
      </TextBox>
    </Box>
  );
};

const Box = styled(FlexBox)`
  height: 30px;
`;

EmptyList.propTypes = {
  text: PropTypes.string,
};

const SwiperItem = ({ item, itemProps }) => {
  return (
    <ChipSearch
      style={{ maxWidth: '138px' }}
      font-size={theme.font.size.$13}
      type={'button'}
      closable={true}
      onClick={itemProps.onClick}
      onClose={() => itemProps.onClose(item.keyword)}
    >
      {item?.keyword}
    </ChipSearch>
  );
};

SwiperItem.propTypes = {
  item: PropTypes.shape({
    keyword: PropTypes.string,
  }),
  itemProps: PropTypes.object,
};

const SearchHistory = ({ keywordList, onSearch, handleDelete, handleDeleteAll }) => {
  const isEmpty = useMemo(() => {
    return keywordList?.length === 0;
  }, [keywordList?.length]);
  const showHistory = useMemo(() => {
    return keywordList?.length > 0;
  }, [keywordList?.length]);
  const mappedHistoryList = useMemo(() => {
    return keywordList?.slice(0, 10);
  }, [keywordList]);

  return (
    <Wrapper data-ds-label2={'g_recent_search'}>
      <SearchHistoryHeader handleDeleteAll={handleDeleteAll} />
      <Spacing top={20} />
      {isEmpty && <EmptyList text={'최근 저장된 검색어가 없습니다.'} />}
      {showHistory && (
        <Swiper
          width={'380px'}
          arrowProps={{ type: '4' }}
          itemList={mappedHistoryList}
          itemProps={{ width: 'auto', onClick: onSearch, onClose: handleDelete }}
          itemComponent={SwiperItem}
          carouselProps={{ slidesPerView: 'auto', loop: false, spaceBetween: 5 }}
        />
      )}
      <Spacing top={9} />
      <HorizontalDivider />
    </Wrapper>
  );
};

const Wrapper = styled(FlexBoxColumn)`
  width: 100%;
  height: 85px;
`;

export default SearchHistory;

SearchHistory.propTypes = {
  keywordList: PropTypes.array,
  onSearch: PropTypes.func,
  handleDelete: PropTypes.func,
  handleDeleteAll: PropTypes.func,
};
